function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var UploadRomOverlay = require('./overlays/upload-rom');
var LoadRomOverlay = require('./overlays/load-rom');
var SaveGamesOverlay = require('./overlays/save-games');
var ControlsOverlay = require('./overlays/controls');
var NwasmMain = /*#__PURE__*/function () {
  function NwasmMain(app) {
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.nwasm-main';
    _classCallCheck(this, NwasmMain);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.games = [];
    this.launching = false;
    this.upload_overlay = new UploadRomOverlay(app, mod);
    this.load_overlay = new LoadRomOverlay(app, mod);
    this.save_overlay = new SaveGamesOverlay(app, mod);
    this.controls_overlay = new ControlsOverlay(app, mod);
  }
  return _createClass(NwasmMain, [{
    key: "hide",
    value: function hide() {
      var obj = document.querySelector('.nwasm-main');
      if (obj) {
        obj.style.display = 'none';
      }
      try {
        document.body.classList.add('nwasm-playing');
      } catch (err) {}
      // Active game: restore the emulator game menu and canvas.
      try {
        var menu = document.querySelector('.game-menu');
        if (menu) {
          menu.style.display = '';
        }
        var canvas = document.getElementById('canvas');
        if (canvas) {
          canvas.style.display = '';
        }
      } catch (err) {}
    }
  }, {
    key: "show",
    value: function show() {
      var obj = document.querySelector('.nwasm-main');
      if (obj) {
        obj.style.display = '';
      }
      try {
        document.body.classList.remove('nwasm-playing');
      } catch (err) {}
      this.hide_launcher_menu();
    }
  }, {
    key: "return_to_launcher",
    value: function return_to_launcher() {
      try {
        var canvas = document.getElementById('canvas');
        if (canvas) {
          canvas.style.display = 'none';
        }
      } catch (err) {}
      this.show();
      this.render();
    }
  }, {
    key: "hide_launcher_menu",
    value: function hide_launcher_menu() {
      // Launcher: hide Chat/Share/Game menu until a ROM is running.
      try {
        var _this$mod;
        if ((_this$mod = this.mod) !== null && _this$mod !== void 0 && (_this$mod = _this$mod.menu) !== null && _this$mod !== void 0 && _this$mod.hide) {
          this.mod.menu.hide();
          return;
        }
        var menu = document.querySelector('.game-menu');
        if (menu) {
          menu.style.display = 'none';
        }
      } catch (err) {}
    }
  }, {
    key: "hide_loading",
    value: function hide_loading() {
      this.load_overlay.hide();
      this.launching = false;
    }
  }, {
    key: "open_upload",
    value: function open_upload() {
      this.mod.uploaded_rom = false;
      this.mod.active_rom_name = '';
      this.upload_overlay.render();
    }
  }, {
    key: "open_save_games",
    value: function () {
      var _open_save_games = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.mod.active_rom_sig && this.mod.active_rom_name) {
                this.mod.active_rom_sig = this.app.crypto.hash(this.mod.active_rom_name);
              }
              _context.n = 1;
              return this.save_overlay.render();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open_save_games() {
        return _open_save_games.apply(this, arguments);
      }
      return open_save_games;
    }()
  }, {
    key: "open_controls",
    value: function open_controls() {
      this.controls_overlay.render();
    }

    //
    // Find all games available to this user:
    //   1. locally archived ROMs
    //   2. N-WASM ROM NFTs
    //   3. Vault NFTs whose filename indicates an N64 ROM
    //
    // Metadata only — does not download or initialize ROMs.
    //
  }, {
    key: "load_games",
    value: function () {
      var _load_games = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _app$options,
          _this = this,
          _app$options2;
        var games, seen, mod, app, vault_nft_index, index_dirty, nfts, vault_games_by_file, _loop, _ret, z, registered, i, _g$vault, _g$vault2, g;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              games = [];
              seen = {};
              mod = this.mod;
              app = this.app;
              if (!app.options.nwasm) {
                app.options.nwasm = {};
              }
              if (!app.options.nwasm.vault_nft_index || _typeof(app.options.nwasm.vault_nft_index) !== 'object') {
                app.options.nwasm.vault_nft_index = {};
              }
              vault_nft_index = app.options.nwasm.vault_nft_index;
              index_dirty = false; //
              // Discover by field1 only. Do not use Archive `owner` (access-script hash)
              // and do not require field2 — a mismatched/empty field2 previously made
              // verified saves invisible to the library.
              //
              _context3.n = 1;
              return new Promise(function (resolve) {
                app.storage.loadTransactions({
                  field1: mod.name,
                  limit: 100
                }, function (txs) {
                  try {
                    for (var i = 0; i < (txs || []).length; i++) {
                      var _msg$data;
                      var tx = txs[i];
                      var msg = tx.returnMessage() || {};
                      if (msg.request === 'upload savegame') {
                        continue;
                      }
                      if (msg.module && msg.module !== mod.name && msg.module !== 'Nwasm') {
                        continue;
                      }
                      if (!tx.signature || seen[tx.signature]) {
                        continue;
                      }
                      seen[tx.signature] = 1;
                      games.push({
                        sig: tx.signature,
                        title: (msg.title || msg.name || ((_msg$data = msg.data) === null || _msg$data === void 0 ? void 0 : _msg$data.name) || 'Untitled ROM').trim(),
                        id: msg.id || '',
                        source: 'archive',
                        rental: false,
                        expires_at: null
                      });
                    }
                  } catch (err) {
                    console.log('error loading archived Nwasm games for launcher: ' + err);
                  }
                  resolve();
                }, 'localhost');
              });
            case 1:
              nfts = ((_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.wallet) === null || _app$options === void 0 ? void 0 : _app$options.nfts) || [];
              vault_games_by_file = {};
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var nft_entry, nft_sig, nft_type, _nft_entry$slip, meta, indexed, file, indexed_ok, _nft_entry$slip2, _nft_entry$slip3, _nft_entry$slip4, mint, msg, data, filename, file_id, _rental_meta, rental_meta, game_entry, file_key, existing, _t;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.p = _context2.n) {
                    case 0:
                      nft_entry = nfts[z];
                      nft_sig = nft_entry === null || nft_entry === void 0 ? void 0 : nft_entry.tx_sig;
                      if (!(!nft_sig || seen[nft_sig])) {
                        _context2.n = 1;
                        break;
                      }
                      return _context2.a(2, 0);
                    case 1:
                      nft_type = '';
                      _context2.p = 2;
                      nft_type = app.wallet.extractNFTType(nft_entry === null || nft_entry === void 0 || (_nft_entry$slip = nft_entry.slip3) === null || _nft_entry$slip === void 0 ? void 0 : _nft_entry$slip.utxo_key);
                      _context2.n = 4;
                      break;
                    case 3:
                      _context2.p = 3;
                      _t = _context2.v;
                      return _context2.a(2, 0);
                    case 4:
                      if (!(nft_type === 'nwasm-nft-mod')) {
                        _context2.n = 6;
                        break;
                      }
                      _context2.n = 5;
                      return new Promise(function (resolve) {
                        app.storage.loadTransactions({
                          sig: nft_sig
                        }, function (txs) {
                          try {
                            var _msg$data2, _msg$data3;
                            if (!txs || txs.length < 1) {
                              resolve(null);
                              return;
                            }
                            var msg = txs[0].returnMessage() || {};
                            resolve({
                              title: msg.title || msg.name || ((_msg$data2 = msg.data) === null || _msg$data2 === void 0 ? void 0 : _msg$data2.title) || ((_msg$data3 = msg.data) === null || _msg$data3 === void 0 ? void 0 : _msg$data3.name) || '',
                              id: msg.id || nft_sig
                            });
                          } catch (err) {
                            resolve(null);
                          }
                        }, 'localhost');
                      });
                    case 5:
                      meta = _context2.v;
                      seen[nft_sig] = 1;
                      games.push({
                        sig: nft_sig,
                        title: ((meta === null || meta === void 0 ? void 0 : meta.title) || 'N64 ROM').trim(),
                        id: (meta === null || meta === void 0 ? void 0 : meta.id) || nft_sig,
                        source: 'nft',
                        rental: false,
                        expires_at: null
                      });
                      return _context2.a(2, 0);
                    case 6:
                      if (_this.isVaultBackedRomNftType(nft_type)) {
                        _context2.n = 7;
                        break;
                      }
                      return _context2.a(2, 0);
                    case 7:
                      indexed = vault_nft_index[nft_sig];
                      if (!((indexed === null || indexed === void 0 ? void 0 : indexed.status) === 'skip')) {
                        _context2.n = 8;
                        break;
                      }
                      return _context2.a(2, 0);
                    case 8:
                      file = null;
                      indexed_ok = (indexed === null || indexed === void 0 ? void 0 : indexed.status) === 'rom' && indexed.file_id && (!_this.isRentalNftType(nft_type) || indexed.expires_at != null);
                      if (!indexed_ok) {
                        _context2.n = 9;
                        break;
                      }
                      file = indexed;
                      _context2.n = 13;
                      break;
                    case 9:
                      _context2.n = 10;
                      return new Promise(function (resolve) {
                        app.storage.loadTransactions({
                          sig: nft_sig
                        }, function (txs) {
                          try {
                            if (!txs || txs.length < 1) {
                              resolve(null);
                              return;
                            }
                            resolve(txs[0]);
                          } catch (err) {
                            resolve(null);
                          }
                        }, 'localhost');
                      });
                    case 10:
                      mint = _context2.v;
                      if (mint) {
                        _context2.n = 11;
                        break;
                      }
                      return _context2.a(2, 0);
                    case 11:
                      msg = mint.returnMessage() || {};
                      data = msg.data && _typeof(msg.data) === 'object' ? msg.data : {};
                      filename = data.filename != null ? String(data.filename) : '';
                      file_id = data.file_id != null ? String(data.file_id) : '';
                      if (!(!file_id || !_this.is_n64_rom_filename(filename))) {
                        _context2.n = 12;
                        break;
                      }
                      vault_nft_index[nft_sig] = {
                        status: 'skip'
                      };
                      index_dirty = true;
                      return _context2.a(2, 0);
                    case 12:
                      _rental_meta = _this.vaultRentalMeta(nft_type, data);
                      file = {
                        status: 'rom',
                        nft_id: nft_entry.id || nft_sig,
                        tx_sig: nft_sig,
                        file_id: file_id,
                        filename: filename,
                        link: data.link != null ? String(data.link) : '',
                        slip1_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip2 = nft_entry.slip1) === null || _nft_entry$slip2 === void 0 ? void 0 : _nft_entry$slip2.utxo_key) || '',
                        slip2_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip3 = nft_entry.slip2) === null || _nft_entry$slip3 === void 0 ? void 0 : _nft_entry$slip3.utxo_key) || '',
                        slip3_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip4 = nft_entry.slip3) === null || _nft_entry$slip4 === void 0 ? void 0 : _nft_entry$slip4.utxo_key) || '',
                        file_access_script: data.file_access_script || null,
                        path: Array.isArray(data.path) ? data.path : [],
                        nft_type: nft_type,
                        rental: _rental_meta.rental,
                        expires_at: _rental_meta.expires_at
                      };
                      vault_nft_index[nft_sig] = file;
                      index_dirty = true;
                    case 13:
                      seen[nft_sig] = 1;
                      if (file.nft_id) {
                        seen[file.nft_id] = 1;
                      }
                      rental_meta = _this.vaultRentalMeta(nft_type, {
                        expires_at: file.expires_at,
                        file_access_script: file.file_access_script,
                        path: file.path
                      });
                      if (file.rental === true) {
                        rental_meta.rental = true;
                      }
                      if (file.expires_at != null && rental_meta.expires_at == null) {
                        rental_meta.expires_at = file.expires_at;
                      }
                      game_entry = {
                        sig: nft_sig,
                        title: _this.vault_game_title(file.filename || ''),
                        id: file.nft_id || nft_sig,
                        source: 'vault',
                        vault: file,
                        nft_type: nft_type,
                        rental: rental_meta.rental,
                        expires_at: rental_meta.expires_at
                      };
                      file_key = String(file.file_id || '');
                      existing = file_key ? vault_games_by_file[file_key] : null;
                      if (!existing || _this.vaultEntitlementRank(nft_type) > _this.vaultEntitlementRank(existing.nft_type)) {
                        vault_games_by_file[file_key || nft_sig] = game_entry;
                      } else if (_this.vaultEntitlementRank(nft_type) === _this.vaultEntitlementRank(existing.nft_type) && Number(game_entry.expires_at) > Number(existing.expires_at || 0)) {
                        vault_games_by_file[file_key] = game_entry;
                      }
                    case 14:
                      return _context2.a(2);
                  }
                }, _loop, null, [[2, 3]]);
              });
              z = 0;
            case 2:
              if (!(z < nfts.length)) {
                _context3.n = 5;
                break;
              }
              return _context3.d(_regeneratorValues(_loop()), 3);
            case 3:
              _ret = _context3.v;
              if (!(_ret === 0)) {
                _context3.n = 4;
                break;
              }
              return _context3.a(3, 4);
            case 4:
              z++;
              _context3.n = 2;
              break;
            case 5:
              Object.keys(vault_games_by_file).forEach(function (key) {
                games.push(vault_games_by_file[key]);
              });
              if (index_dirty) {
                app.storage.saveOptions();
              }

              //
              // Games explicitly registered via Nwasm.addGame() after a successful
              // Library save (Archive / Vault / NFT). Ensures the new entry is present
              // before the next render even when wallet discovery still lags.
              //
              registered = ((_app$options2 = app.options) === null || _app$options2 === void 0 || (_app$options2 = _app$options2.nwasm) === null || _app$options2 === void 0 ? void 0 : _app$options2.library) || [];
              i = 0;
            case 6:
              if (!(i < registered.length)) {
                _context3.n = 11;
                break;
              }
              g = registered[i];
              if (!(!(g !== null && g !== void 0 && g.sig) || seen[g.sig])) {
                _context3.n = 7;
                break;
              }
              return _context3.a(3, 10);
            case 7:
              if (!(g.id && seen[g.id])) {
                _context3.n = 8;
                break;
              }
              return _context3.a(3, 10);
            case 8:
              if (!((_g$vault = g.vault) !== null && _g$vault !== void 0 && _g$vault.file_id && vault_games_by_file[String(g.vault.file_id)])) {
                _context3.n = 9;
                break;
              }
              return _context3.a(3, 10);
            case 9:
              seen[g.sig] = 1;
              if (g.id) {
                seen[g.id] = 1;
              }
              games.push({
                sig: g.sig,
                title: (g.title || 'Untitled ROM').trim(),
                id: g.id || g.sig,
                source: g.source || 'archive',
                vault: g.vault || null,
                nft_type: g.nft_type || ((_g$vault2 = g.vault) === null || _g$vault2 === void 0 ? void 0 : _g$vault2.nft_type) || '',
                rental: g.rental === true,
                expires_at: g.expires_at != null ? g.expires_at : null
              });
            case 10:
              i++;
              _context3.n = 6;
              break;
            case 11:
              games.sort(function (a, b) {
                return a.title.localeCompare(b.title);
              });
              return _context3.a(2, games);
          }
        }, _callee2, this);
      }));
      function load_games() {
        return _load_games.apply(this, arguments);
      }
      return load_games;
    }()
  }, {
    key: "isVaultBackedRomNftType",
    value: function isVaultBackedRomNftType() {
      var nft_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return nft_type === 'vault-nft-key' || nft_type === 'vault' || nft_type === 'vault-nft-rental' || nft_type === 'store-nft-rental';
    }
  }, {
    key: "isRentalNftType",
    value: function isRentalNftType() {
      var nft_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return nft_type === 'vault-nft-rental' || nft_type === 'store-nft-rental';
    }
  }, {
    key: "vaultEntitlementRank",
    value: function vaultEntitlementRank() {
      var nft_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (nft_type === 'vault-nft-key' || nft_type === 'vault') {
        return 3;
      }
      if (nft_type === 'vault-nft-rental') {
        return 2;
      }
      if (nft_type === 'store-nft-rental') {
        return 1;
      }
      return 0;
    }

    // store-nft-rental: mint/transfer data.expires_at is authoritative, then hop.
    // vault-nft-rental: hop expires_at (Vault firstUndelegatedHopFromRental), else data.expires_at.
  }, {
    key: "vaultRentalMeta",
    value: function vaultRentalMeta() {
      var nft_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rental = this.isRentalNftType(nft_type);
      var expires_at = null;
      if (!rental) {
        return {
          rental: false,
          expires_at: null
        };
      }
      var hop_expires = null;
      var vault_mod = this.app.modules.returnModule('Vault');
      if (vault_mod && typeof vault_mod.firstUndelegatedHopFromRental === 'function') {
        try {
          var hop = vault_mod.firstUndelegatedHopFromRental(data === null || data === void 0 ? void 0 : data.file_access_script, data === null || data === void 0 ? void 0 : data.path);
          if ((hop === null || hop === void 0 ? void 0 : hop.expires_at) != null && hop.expires_at !== '') {
            hop_expires = Number(hop.expires_at);
          }
        } catch (err) {}
      }
      var data_expires = null;
      if ((data === null || data === void 0 ? void 0 : data.expires_at) != null && data.expires_at !== '') {
        data_expires = Number(data.expires_at);
      }
      if (nft_type === 'store-nft-rental') {
        expires_at = data_expires != null ? data_expires : hop_expires;
      } else {
        expires_at = hop_expires != null ? hop_expires : data_expires;
      }
      if (expires_at != null && !Number.isFinite(expires_at)) {
        expires_at = null;
      }
      return {
        rental: true,
        expires_at: expires_at
      };
    }
  }, {
    key: "is_n64_rom_filename",
    value: function is_n64_rom_filename() {
      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var name = String(filename || '');
      return /\.(z64|n64|v64)$/i.test(name) || name.toLowerCase().includes('64');
    }
  }, {
    key: "vault_game_title",
    value: function vault_game_title() {
      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var name = String(filename || '').trim();
      return name.replace(/\.(z64|n64|v64)$/i, '').trim() || name || 'N64 ROM';
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this2 = this;
        var html, pending_sig, raw, _JSON$parse, _raw, pending;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.load_games();
            case 1:
              this.games = _context5.v;
              html = MainTemplate(this.app, this.mod, this.games);
              if (document.querySelector('.nwasm-main')) {
                this.app.browser.replaceElementBySelector(html, '.nwasm-main');
              } else {
                this.app.browser.addElementToSelector(html, this.container);
              }
              this.launching = false;
              this.hide_launcher_menu();
              this.attachEvents();

              // After a different-ROM page reload, resume the library game the user picked.
              pending_sig = '';
              try {
                raw = sessionStorage.getItem('nwasm-pending-launch');
                if (raw) {
                  sessionStorage.removeItem('nwasm-pending-launch');
                  pending_sig = ((_JSON$parse = JSON.parse(raw)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.sig) || '';
                }
              } catch (err) {
                pending_sig = '';
              }
              if (!(pending_sig && this.games.some(function (g) {
                return g.sig === pending_sig;
              }))) {
                _context5.n = 2;
                break;
              }
              setTimeout(function () {
                _this2.launch_game(pending_sig);
              }, 0);
              return _context5.a(2);
            case 2:
              // Play Now from the Arcade overlay: ephemeral ROM queued before navigation.
              try {
                _raw = sessionStorage.getItem('nwasm-pending-ephemeral');
                if (_raw) {
                  sessionStorage.removeItem('nwasm-pending-ephemeral');
                  pending = JSON.parse(_raw);
                  if (pending !== null && pending !== void 0 && pending.data) {
                    setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                      var ab;
                      return _regenerator().w(function (_context4) {
                        while (1) switch (_context4.n) {
                          case 0:
                            ab = _this2.mod.convertBase64ToByteArray(pending.data);
                            _context4.n = 1;
                            return _this2.mod.playEphemeralRom(ab, pending.file_name || 'Selected ROM');
                          case 1:
                            return _context4.a(2);
                        }
                      }, _callee3);
                    })), 0);
                  }
                }
              } catch (err) {}
            case 3:
              return _context5.a(2);
          }
        }, _callee4, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var root = document.querySelector('.nwasm-main');
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-action="upload"]').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          _this3.open_upload();
        };
      });
      root.querySelectorAll('.game').forEach(function (card) {
        card.onclick = function (e) {
          e.preventDefault();
          var sig = card.getAttribute('data-sig');
          if (sig) {
            _this3.launch_game(sig, card);
          }
        };
      });
    }

    //
    // Library card → loading overlay → fetch ROM bytes → extractRom → LoadEmulator.
    // Overlay is dismissed inside LoadEmulator after initAudio (not here).
    //
  }, {
    key: "launch_game",
    value: function () {
      var _launch_game = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(sig) {
        var _this4 = this;
        var card,
          game,
          title,
          yield_for_paint,
          fail_launch,
          exp,
          _args0 = arguments,
          _t4;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              card = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : null;
              if (!(this.launching || !sig)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              this.launching = true;
              // Used by LoadEmulator when a different ROM requires a cold Module reload.
              this.mod.launch_sig = sig;
              this.mod.clearRentalTimer();
              try {
                sessionStorage.removeItem('nwasm-launched-from-arcade');
              } catch (_) {}
              if (card) {
                card.classList.add('loading');
                card.setAttribute('aria-busy', 'true');
              }
              game = this.games.find(function (g) {
                return g.sig === sig;
              });
              title = (game === null || game === void 0 ? void 0 : game.title) || 'Loading game…';
              this.hide();
              this.load_overlay.render({
                title: title,
                message: 'Initializing emulator — this can take a while for large ROMs. The page may appear frozen; please wait.'
              });

              // Let the overlay paint before archive/Vault/CPU work freezes the thread.
              yield_for_paint = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                  return _regenerator().w(function (_context6) {
                    while (1) switch (_context6.n) {
                      case 0:
                        _context6.n = 1;
                        return new Promise(function (resolve) {
                          requestAnimationFrame(function () {
                            requestAnimationFrame(resolve);
                          });
                        });
                      case 1:
                        _context6.n = 2;
                        return new Promise(function (resolve) {
                          return setTimeout(resolve, 50);
                        });
                      case 2:
                        return _context6.a(2);
                    }
                  }, _callee5);
                }));
                return function yield_for_paint() {
                  return _ref2.apply(this, arguments);
                };
              }();
              fail_launch = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(message) {
                  return _regenerator().w(function (_context7) {
                    while (1) switch (_context7.n) {
                      case 0:
                        alert(message);
                        _this4.hide_loading();
                        _this4.show();
                        _context7.n = 1;
                        return _this4.render();
                      case 1:
                        return _context7.a(2);
                    }
                  }, _callee6);
                }));
                return function fail_launch(_x2) {
                  return _ref3.apply(this, arguments);
                };
              }();
              _context0.n = 2;
              return yield_for_paint();
            case 2:
              if (!(game !== null && game !== void 0 && game.rental)) {
                _context0.n = 4;
                break;
              }
              exp = game.expires_at != null ? Number(game.expires_at) : NaN;
              if (!(!Number.isFinite(exp) || Date.now() >= exp)) {
                _context0.n = 4;
                break;
              }
              _context0.n = 3;
              return fail_launch('This rental has expired.');
            case 3:
              return _context0.a(2);
            case 4:
              _context0.p = 4;
              if (!((game === null || game === void 0 ? void 0 : game.source) === 'vault')) {
                _context0.n = 5;
                break;
              }
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                var _vault_data, _vault_data12, _vault_data13;
                var vault_mod, vault_data, mint, mint_sig, _mint$returnMessage, _this4$app$options, _vault_data3, _vault_data4, _vault_data5, _vault_data6, _nft_entry$slip5, _vault_data7, _nft_entry$slip6, _vault_data8, _nft_entry$slip7, _vault_data9, _vault_data0, _vault_data1, _vault_data10, _vault_data11, data, nfts, nft_entry, on_file, nft_type, _t2;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.p = _context8.n) {
                    case 0:
                      _context8.n = 1;
                      return yield_for_paint();
                    case 1:
                      vault_mod = _this4.app.modules.returnModule('Vault');
                      vault_data = game.vault || null;
                      mint = null; // Refresh mint-tx fields for access (slips / file_id); do not ask Vault for metadata.
                      mint_sig = ((_vault_data = vault_data) === null || _vault_data === void 0 ? void 0 : _vault_data.tx_sig) || game.sig || '';
                      if (!mint_sig) {
                        _context8.n = 5;
                        break;
                      }
                      _context8.p = 2;
                      _context8.n = 3;
                      return new Promise(function (resolve) {
                        _this4.app.storage.loadTransactions({
                          sig: mint_sig
                        }, function (txs) {
                          resolve(txs && txs.length ? txs[0] : null);
                        }, 'localhost');
                      });
                    case 3:
                      mint = _context8.v;
                      if (mint) {
                        data = ((_mint$returnMessage = mint.returnMessage()) === null || _mint$returnMessage === void 0 ? void 0 : _mint$returnMessage.data) || {};
                        nfts = ((_this4$app$options = _this4.app.options) === null || _this4$app$options === void 0 || (_this4$app$options = _this4$app$options.wallet) === null || _this4$app$options === void 0 ? void 0 : _this4$app$options.nfts) || [];
                        nft_entry = nfts.find(function (n) {
                          var _vault_data2;
                          return ((_vault_data2 = vault_data) === null || _vault_data2 === void 0 ? void 0 : _vault_data2.nft_id) && n.id === vault_data.nft_id || n.tx_sig === mint_sig;
                        }) || null;
                        vault_data = {
                          nft_id: ((_vault_data3 = vault_data) === null || _vault_data3 === void 0 ? void 0 : _vault_data3.nft_id) || (nft_entry === null || nft_entry === void 0 ? void 0 : nft_entry.id) || game.id || mint_sig,
                          tx_sig: mint_sig,
                          file_id: data.file_id != null ? String(data.file_id) : ((_vault_data4 = vault_data) === null || _vault_data4 === void 0 ? void 0 : _vault_data4.file_id) || '',
                          filename: data.filename != null ? String(data.filename) : ((_vault_data5 = vault_data) === null || _vault_data5 === void 0 ? void 0 : _vault_data5.filename) || '',
                          link: data.link != null ? String(data.link) : ((_vault_data6 = vault_data) === null || _vault_data6 === void 0 ? void 0 : _vault_data6.link) || '',
                          slip1_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip5 = nft_entry.slip1) === null || _nft_entry$slip5 === void 0 ? void 0 : _nft_entry$slip5.utxo_key) || ((_vault_data7 = vault_data) === null || _vault_data7 === void 0 ? void 0 : _vault_data7.slip1_utxokey) || '',
                          slip2_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip6 = nft_entry.slip2) === null || _nft_entry$slip6 === void 0 ? void 0 : _nft_entry$slip6.utxo_key) || ((_vault_data8 = vault_data) === null || _vault_data8 === void 0 ? void 0 : _vault_data8.slip2_utxokey) || '',
                          slip3_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip7 = nft_entry.slip3) === null || _nft_entry$slip7 === void 0 ? void 0 : _nft_entry$slip7.utxo_key) || ((_vault_data9 = vault_data) === null || _vault_data9 === void 0 ? void 0 : _vault_data9.slip3_utxokey) || '',
                          file_access_script: data.file_access_script || ((_vault_data0 = vault_data) === null || _vault_data0 === void 0 ? void 0 : _vault_data0.file_access_script) || null,
                          path: Array.isArray(data.path) ? data.path : ((_vault_data1 = vault_data) === null || _vault_data1 === void 0 ? void 0 : _vault_data1.path) || [],
                          nft_type: game.nft_type || ((_vault_data10 = vault_data) === null || _vault_data10 === void 0 ? void 0 : _vault_data10.nft_type) || '',
                          expires_at: data.expires_at != null ? Number(data.expires_at) : game.expires_at != null ? Number(game.expires_at) : (_vault_data11 = vault_data) === null || _vault_data11 === void 0 ? void 0 : _vault_data11.expires_at
                        };
                      }
                      _context8.n = 5;
                      break;
                    case 4:
                      _context8.p = 4;
                      _t2 = _context8.v;
                      console.warn('Nwasm: unable to refresh Vault Access Key mint tx:', _t2);
                    case 5:
                      if (!(!vault_mod || !vault_mod.peer || !((_vault_data12 = vault_data) !== null && _vault_data12 !== void 0 && _vault_data12.file_id))) {
                        _context8.n = 7;
                        break;
                      }
                      _context8.n = 6;
                      return fail_launch(!(vault_mod !== null && vault_mod !== void 0 && vault_mod.peer) ? 'Vault peer not connected' : 'Vault ROM metadata incomplete');
                    case 6:
                      return _context8.a(2);
                    case 7:
                      on_file = function on_file(base64) {
                        if (!base64) {
                          void fail_launch('Unable to download ROM from Vault');
                          return;
                        }
                        if (_this4.mod.isRentalExpired(game)) {
                          _this4.mod.clearRentalRomFromMemory();
                          void fail_launch('This rental has expired.');
                          return;
                        }
                        try {
                          var tx = _this4.mod.unpackVaultFile(base64, {
                            id: game.id || game.sig || '',
                            title: game.title || vault_data.filename || '',
                            filename: vault_data.filename || ''
                          });
                          _this4.mod.extractRom(tx);
                          _this4.mod.armRentalExpiry(game);
                        } catch (err) {
                          console.log('Error launching Vault ROM: ' + err);
                          void fail_launch('Error launching Vault ROM');
                        }
                      };
                      nft_type = game.nft_type || vault_data.nft_type || '';
                      if (!(nft_type === 'store-nft-rental')) {
                        _context8.n = 10;
                        break;
                      }
                      if (!(typeof vault_mod.sendAccessRentalFileRequest !== 'function')) {
                        _context8.n = 9;
                        break;
                      }
                      _context8.n = 8;
                      return fail_launch('Vault rental access is unavailable');
                    case 8:
                      return _context8.a(2);
                    case 9:
                      vault_mod.sendAccessRentalFileRequest({
                        tx: mint,
                        data: {
                          file_id: vault_data.file_id,
                          file_access_script: vault_data.file_access_script,
                          path: vault_data.path || [],
                          expires_at: game.expires_at != null ? game.expires_at : vault_data.expires_at
                        },
                        file_id: vault_data.file_id,
                        file_access_script: vault_data.file_access_script
                      }, on_file);
                      return _context8.a(2);
                    case 10:
                      if ((_vault_data13 = vault_data) !== null && _vault_data13 !== void 0 && _vault_data13.nft_id) {
                        _context8.n = 12;
                        break;
                      }
                      _context8.n = 11;
                      return fail_launch('Vault ROM metadata incomplete');
                    case 11:
                      return _context8.a(2);
                    case 12:
                      vault_mod.sendAccessFileRequest(vault_data, null, on_file);
                    case 13:
                      return _context8.a(2);
                  }
                }, _callee7, null, [[2, 4]]);
              })), 0);
              return _context0.a(2);
            case 5:
              this.app.storage.loadTransactions({
                sig: sig
              }, function (txs) {
                if (!txs || txs.length < 1) {
                  void fail_launch('Unable to load this ROM.');
                  return;
                }
                setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
                  var _t3;
                  return _regenerator().w(function (_context9) {
                    while (1) switch (_context9.p = _context9.n) {
                      case 0:
                        _context9.n = 1;
                        return yield_for_paint();
                      case 1:
                        _context9.p = 1;
                        if (!_this4.mod.isRentalExpired(game)) {
                          _context9.n = 3;
                          break;
                        }
                        _this4.mod.clearRentalRomFromMemory();
                        _context9.n = 2;
                        return fail_launch('This rental has expired.');
                      case 2:
                        return _context9.a(2);
                      case 3:
                        _this4.mod.extractRom(txs[0]);
                        _this4.mod.armRentalExpiry(game);
                        _context9.n = 5;
                        break;
                      case 4:
                        _context9.p = 4;
                        _t3 = _context9.v;
                        console.log('Error launching ROM: ' + _t3);
                        _context9.n = 5;
                        return fail_launch('Error launching ROM');
                      case 5:
                        return _context9.a(2);
                    }
                  }, _callee8, null, [[1, 4]]);
                })), 0);
              }, 'localhost');
              _context0.n = 7;
              break;
            case 6:
              _context0.p = 6;
              _t4 = _context0.v;
              console.log('Error launching ROM: ' + _t4);
              _context0.n = 7;
              return fail_launch('Error launching ROM');
            case 7:
              return _context0.a(2);
          }
        }, _callee9, this, [[4, 6]]);
      }));
      function launch_game(_x) {
        return _launch_game.apply(this, arguments);
      }
      return launch_game;
    }()
  }]);
}();
module.exports = NwasmMain;